@if (topPlayers$ | async; as topPlayers) {
  <div class="leaders">
    @if (topPlayers.length) {
      @if (!hideTitle) {
        <div class="leaders__title">{{'t.leaders' | translate}}:</div>
      }
      @for (topPlayer of topPlayers; track $index) {
        <div id="leaders" class="leaders__item">
          @if (topPlayer?.current_user) {
            <div class="leaders__item--dot"></div>
          }
          <div class="leaders__item--place text-gradient">{{topPlayer?.award_place}}</div>
          <div class="leaders__item--nickname" [ngClass]="{'text-gradient': topPlayer?.current_user}">
            {{topPlayer?.nickname}}
          </div>
          <div class="leaders__item--score"
            [ngClass]="{'text-gradient': topPlayer?.current_user, 'bigger-font': topPlayer?.current_user}">
            {{(topPlayer?.rate * 8) | number: '2.0-1'}}
          </div>
        </div>
      }
    }
  </div>
}
@if (!hideBtn) {
  <div (click)="showLeaders()" class="card-gradient">
    <div class="link__text">
      {{'t.all' | translate}}<br>
      <span>{{'t.leaders' | translate}}</span>
    </div>
    <div class="link">
      <i class="icon-arrow"></i>
    </div>
  </div>
}
